import { useFormikContext } from 'formik';
import isEqual from 'lodash/isEqual';
import { func, number } from 'prop-types';
import { useCallback, useEffect } from 'react';

function AutoSave({ delay, onSave }) {
  const { values, initialValues } = useFormikContext();

  const isSameValueAsInitialValue = useCallback(v => isEqual(v, initialValues), [initialValues]);
  const onFormSubmit = useCallback(async () => {
    if (!isSameValueAsInitialValue(values)) onSave(values);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values, isSameValueAsInitialValue]);

  useEffect(() => {
    const timer = setTimeout(() => onFormSubmit(), delay);
    return () => clearTimeout(timer);
  }, [onFormSubmit, delay]);

  return null;
}

export default AutoSave;

AutoSave.defaultProps = {
  delay: 500,
  onSave: () => null,
};

AutoSave.propTypes = {
  delay: number,
  onSave: func,
};
